import { Box, Form, LoaderNew, ModBox } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import { Container } from '../../../comps/Container'
import { useLazyApiData, useStores } from '../../../data/store'
import { downloadWeb, sendDataForDownload } from '../../../network/downloadReceipt'
import { ActionButtons } from './ActionButton'
import { TransactionSuccessForm } from './TransactionSuccessForm'

export const SplitTransactionStatusScreen = () => {
  const { splittedTnxResponses, printReceipt, setMessage, fetchRemittanceStatus } = useStores((store) => ({
    splittedTnxResponses: store.transactionDetails.splittedTnxResponses,
    printReceipt: store.agent.printReceipt,
    setMessage: store.message.setMessage,
    fetchRemittanceStatus: store.transactionDetails.fetchRemittanceStatus,
  }))
  const [printReceiptApi, printReceiptHandler] = useLazyApiData(printReceipt)
  const [fetchRemittanceStatusApi, fetchRemittanceStatusHandler] = useLazyApiData(fetchRemittanceStatus)

  useEffect(() => {
    if (printReceiptHandler.state === 'fulfilled') {
      console.log('api handler ', printReceiptHandler?.data)
      if (printReceiptHandler?.data?.response) {
        handleDownloadResponse(printReceiptHandler.data)
      }
    } else if (printReceiptHandler.state === 'rejected') {
      const message = printReceiptHandler?.data?.message
      setMessage(message ?? 'Failed to download receipt')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printReceiptHandler.state])

  const handleDownloadResponse = (response?: any) => {
    if (window.AepsWebViewInterface) {
      sendDataForDownload(response, onDownloadSuccess, onDownloadFailed)
    } else {
      downloadWeb(response, onDownloadSuccess)
    }
  }

  const onDownloadSuccess = (success: any) => {
    setMessage(success, 'POSITIVE')
  }
  const onDownloadFailed = (error: any) => {
    setMessage(error, 'NEGATIVE')
  }

  const download = useCallback(
    (rrnNo: any) => {
      if (rrnNo?.length > 0) {
        printReceiptApi(rrnNo)
      } else {
        setMessage('Failed to download receipt.', 'NEGATIVE')
      }
    },
    [printReceiptApi, setMessage],
  )

  const fetchStatus = useCallback(
    (idempotentKey: any) => {
      fetchRemittanceStatusApi(idempotentKey)
    },
    [fetchRemittanceStatusApi],
  )

  const getFormData = () => {
    return TransactionSuccessForm({ splittedTnxResponses, fetchStatus, download })
  }
  return (
    <>
      <Container type="refund" showFooter={true}>
        <Form
          formData={getFormData()}
          container={({ children }) => <Box width={'100%'}>{children}</Box>}
          actionButtons={(props) => <ActionButtons {...props} />}
        />
      </Container>
      <ModBox
        width={'100%'}
        height={'100%'}
        position={'absolute'}
        justifyContent={'center'}
        show={[printReceiptHandler.state, fetchRemittanceStatusHandler?.state].includes('pending')}
        backgroundColor={'TRANSPARENT45'}>
        <LoaderNew type={'large'} color={'PRIMARY'} />
      </ModBox>
    </>
  )
}
